import { MouseEvent, useEffect, useRef } from 'react';
import {cn} from '@shortsworks/ui/lib/utils';
import {CircleX} from 'lucide-react';
import {GradientColorStop} from '@shortsworks/ui/components/ColorGenerator/GradientGenerator/types';

interface ColorStopProps {
  containerRect: DOMRect;
  colorStop: GradientColorStop;
  index: number;
  onSelect: (index: number) => void;
  onChange: (colorStop: GradientColorStop, index: number) => void;
  onRemove: (index: number) => void;
  selected?: boolean;
  deletable?: boolean;
}

export function ColorStop({ colorStop, index, onSelect, onChange, onRemove, containerRect, selected, deletable }: ColorStopProps) {
  const colorStopRef = useRef<HTMLDivElement | null>(null);

  const handleClickRemove = (e: MouseEvent) => {
    handleNoOp(e);

    onRemove(index);
  };

  const handleMouseDown = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    onSelect(index);
    // @ts-ignore
      document.addEventListener('mousemove', handleMouseMove);
    // @ts-ignore
      document.addEventListener('mouseup', handleMouseUp);
  };

  const handleNoOp = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleMouseMove = (e: MouseEvent) => {
    const containerRect = colorStopRef.current?.parentElement?.getBoundingClientRect();
    const left = e.clientX - containerRect!.left;
    let offset = Math.min(1, Math.max(0, left / containerRect!.width));

    onChange({
      color: colorStop.color,
      offset,
    }, index);
  };

  const handleMouseUp = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();

    // @ts-ignore
      document.removeEventListener('mousemove', handleMouseMove);
    // @ts-ignore
      document.removeEventListener('mouseup', handleMouseUp);
  };

  return (
    <div
      ref={colorStopRef}
      className="absolute w-[39px] -pt-[50px] -ml-[19.5px] -top-[34px] cursor-move"
      onClick={handleNoOp}
      style={{
        // transform: `translate(${colorStop.offset * (containerRect.width - 2)}px, -34px)`,
        left: `${colorStop.offset * 100}%`,
      }}
    >
      <div onMouseDown={handleMouseDown}>
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="48" viewBox="0 0 39 48" fill="none">
          <g
            filter="url(#filter0_d_5237_14227)"
            className={cn(
              'text-input',
              selected && 'text-primary',
            )}
            stroke={"currentColor"}
          >
            <path
              d="M34.5 19.1111C34.5 27.4567 21.2647 44 19.5 44C17.7353 44 4.5 27.4567 4.5 19.1111C4.5 10.7655 11.2157 4 19.5 4C27.7843 4 34.5 10.7655 34.5 19.1111Z"
              fill="white"></path>
          </g>
          <ellipse cx="19.5" cy="18.9016" rx="12.6316" ry="12.549" fill={colorStop.color} stroke="currentColor" className="text-input"></ellipse>
          <defs>
            <filter x="0.5" y="0" width="38" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                             result="hardAlpha"></feColorMatrix>
              <feOffset></feOffset>
              <feGaussianBlur stdDeviation="2"></feGaussianBlur>
              <feComposite in2="hardAlpha" operator="out"></feComposite>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"></feColorMatrix>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5237_14227"></feBlend>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5237_14227" result="shape"></feBlend>
            </filter>
          </defs>
        </svg>
        {
          deletable && (
            <div
              className="absolute -top-[6px] right-0 w-[12px] h-[12px] cursor-pointer"
              onClick={handleClickRemove}
            >
              <CircleX className="w-[12px] h-[12px]"/>
            </div>
          )
        }
      </div>

      {/*<div*/}
      {/*  className={cn(*/}
      {/*    'flex flex-col w-[24px] h-[42px] py-[3px] rounded-[80px] bg-white border border-input items-center justify-between cursor-pointer',*/}
      {/*    selected && 'border-primary',*/}
      {/*  )}*/}
      {/*  onMouseDown={handleMouseDown}*/}
      {/*>*/}
      {/*  <div*/}
      {/*    className={cn(*/}
      {/*      'w-[16px] h-[16px] rounded-full',*/}
      {/*      colorStop.color.toLowerCase() === '#ffffff' && 'border border-input'*/}
      {/*    )}*/}
      {/*    style={{background: colorStop.color}}></div>*/}
      {/*  <CircleX className="w-[12px] h-[12px]" onClick={handleClickRemove}/>*/}
      {/*</div>*/}
    </div>
  );
}
